<template>
    <v-layout row wrap >
        <v-container xs12 class="pt-0 telaMercadorias">
            
            <div class="header-step">
                <h3>Mercadorias Transportadas</h3>
                <p>Informe as principais mercadorias que transporta.</p>
            </div>
            <v-container grid-list-lg class="pl-0">
                <v-layout row wrap>
                    <v-flex xs12 v-if="dadosOperacionais.mercadorias.length == 0">
                        <small class="error--text">Informe ao menos uma mercadoria *</small>
                    </v-flex>
                    <v-flex xs12 v-else-if="!percentualMercadoriasValid">
                        <small class="error--text">A soma dos percentuais não é de 100 %</small>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-autocomplete label="Mercadoria*"
                        id="txtDadosOperacionaisSelectMercadoria"
                        ref="txtSelectMercadoria"
                        v-model="modelMercadoriaTransportada.mercadoria"
                        :items="lstSelectMercadoria"
                        item-text="descricao"
                        return-object
                        :disabled="percentualMercadoriasValid"
                        :error-messages="errorMessages.mercadoria"
                        
                        ></v-autocomplete>
                    </v-flex>
                        <v-flex xs12 sm3>
                        <v-text-field label="Valor médio por embarque*"
                        id="txtDadosOperacionaisValorMedioMercadoria"
                        ref="txtValorMedioMercadoria"
                        v-model.lazy="modelFormatado.valorMercadoriaTransportada"
                        v-money="maskComputed.maskMoney"
                        :error-messages="errorMessages.txtValorMedioMercadoria"
                        :disabled="percentualMercadoriasValid"
                        required
                        ></v-text-field>
                    </v-flex> 
                    <v-flex xs12 sm3>
                        <v-text-field label="Frequência que transporta*"
                        id="txtDadosOperacionaisPercentualMercadoriaTransportada"
                        ref="txtPercentualMercadoria"
                        v-model.lazy="modelFormatado.percentualMercadoriaTransportada"
                        :disabled="percentualMercadoriasValid"
                        :error-messages="errorMessages.txtPercentualMercadoria"
                        :rules="regras.porcentagemDesconto"
                        maxlength="6"
                        required
                        hint="Informe o percentual com 2 casas decimais no máximo"
                        ></v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm3 text-xs-left class="pl-0">
                        <v-btn id="btnAdicionaMercadoria" 
                            @click="adicionaMercadoria" 
                            color="secondary"
                            :block="$vuetify.breakpoint.xsOnly" 
                            :disabled="percentualMercadoriasValid"
                            class="white--text">
                            ADICIONAR
                        </v-btn>
                    </v-flex>
                        <v-spacer></v-spacer>
                    <v-flex>
                        <span>{{somaPercentual(dadosOperacionais.mercadorias)}}/100%</span>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table :headers="cabecalhoGridMercadorias"
                        :items="dadosOperacionais.mercadorias"
                        hide-actions
                        no-data-text="Nenhuma mercadoria foi adicionada">
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">{{ props.item.mercadoria.descricao }}</td>
                                <td class="text-xs-left">{{ toMoneyString(props.item.valorMedio) }}</td>
                                <td class="text-xs-left">{{ toPercentString(props.item.percentual) }}</td>
                                <td><v-btn :disabled="disableMercadorias" @click.stop="removeMercadoria(props.item.mercadoria.id)" color="primary remove-mercadoria" flat icon><v-icon>delete</v-icon></v-btn></td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs4 md3 class="pl-0">
                        <v-btn flat @click="$emit('voltarMercadoriasTransportadas', true)" color="primary">
                            Voltar
                        </v-btn>
                    </v-flex>
                    <v-flex xs4 md3>
                        <v-btn
                            :disabled="!percentualMercadoriasValid"
                            type="submit"
                            @click="$emit('dadosMercadoriasTransportadas', dadosOperacionais.mercadorias)"
                            color="primary"
                        >
                            proximo
                        </v-btn>
                    </v-flex>  
                </v-layout>
            </v-container>
        </v-container>
    </v-layout>
</template>

<script>
import mask from "@/helpers/mask";
import {VMoney} from 'v-money'
import functions from "@/components/pages/listagem-solicitacoes/functions.js";
import CustomFormat from '@/helpers/custom-format'
import axios from 'axios'
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
    name: 'QARMercadoriasTransportadas',
    directives: {
        money: VMoney
    },
    props: {
        protocolo: String,
        dadosQuestionarioCompleto: {
            type: Object, 
            required: false
        }
    },
    data: () => {
        return {
            validMercadoriasTransportadas: true,
            dadosMercadoriasTransportadas: {
                fluvial: null,
                mudanca: null,
                container: null
            },
            questionarioPai: {},
            questionarioClonado: false,
            dataHoraInicio: '',
            tempoPreenchimentoTotal: '',
            formValidDadosOperacionais: false,
            regras: {
                valorTransportadoMes: [v => CustomFormat.removeMoneyFormat(v) > 0 || "Você precisa informar um valor válido"],
                quantidadeViagensMes: [
                    v => /\d/g.test(v) || "Você precisa informar uma quantidade válida",
                    v => parseInt(v) > 0 || "Você precisa informar uma quantidade válida"
                ],
                maiorValorEmbarcado: [v => CustomFormat.removeMoneyFormat(v) > 0 || "Você precisa informar um valor válido"],
                porcentagemTaxa: [
                    v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
                    v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
                    v => (   (/^(100)$/g.test(v) && v.length < 8 )
                            || (/^(100\,\d{1,3})$/g.test(v) && v.length < 8 )
                            || (/^(\d{2})$/g.test(v) && v.length < 7)
                            || (/^(\d{2}\,\d{1,3})$/g.test(v) && v.length < 7)
                            || (/^(\d{1})$/g.test(v) && v.length < 6)
                            || (/^(\d{1}\,\d{1,3})$/g.test(v) && v.length < 6) )
                            || 'Você precisa informar um valor válido'
                ],
                porcentagemDesconto: [
                    v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
                    v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
                    v => (   (/^(100)$/g.test(v) && v.length < 8 )
                            || (/^(100\,\d{1,2})$/g.test(v) && v.length < 8 )
                            || (/^(\d{2})$/g.test(v) && v.length < 6)
                            || (/^(\d{2}\,\d{1,2})$/g.test(v) && v.length < 6)
                            || (/^(\d{1})$/g.test(v) && v.length < 5)
                            || (/^(\d{1}\,\d{1,2})$/g.test(v) && v.length < 5) )
                            || 'Você precisa informar um valor válido'
                ],
                porcentagemVeiculos: [
                v => ((v == '') || (CustomFormat.removePercentFormat(v) >= 0)) || 'Você precisa informar um valor válido',
                v => ((v == '') || (CustomFormat.removePercentFormat(v) <= 100)) || 'Você precisa informar um valor válido',
                v => ( (v == '') 
                        ||  (/^(100)$/g.test(v) && v.length < 8 )
                        || (/^(100\,\d{1,2})$/g.test(v) && v.length < 8 )
                        || (/^(\d{2})$/g.test(v) && v.length < 6)
                        || (/^(\d{2}\,\d{1,2})$/g.test(v) && v.length < 6)
                        || (/^(\d{1})$/g.test(v) && v.length < 5)
                        || (/^(\d{1}\,\d{1,2})$/g.test(v) && v.length < 5) )
                        || 'Você precisa informar um valor válido'
                ],
            },
            modelFormatado: {
                valorTransportadoMes: 0.0,
                maiorValorEmbarcado: 0.0,
                percentualVeiculoProprio: '',
                percentualVeiculoAgregado: '',
                percentualVeiculoAutonomo: '',
                percentualRotaMaiorFrequencia: '0',
                percentualMercadoriaTransportada: 0,
                valorMercadoriaTransportada: 0.0
            },
            modelRotaMaiorFrequencia: {
                idEstadoOrigem: 0,
                idEstadoDestino: 0,
                percentual: 0
            },
            modelMercadoriaTransportada: {
                mercadoria: {},
                percentual: 0,
                valorMedio: 0
                
            },
            lstSalvarOportunidade: [],
            dadosOperacionais: {
                valorTransportadoMes: 0.0,
                quantidadeViagensMes: 0,
                maiorValorEmbarcado: 0.0,
                percentualVeiculoProprio: 0.0,
                percentualVeiculoAgregado: 0.0,
                percentualVeiculoAutonomo: 0.0,
                fluvial: false,
                mudanca: false,
                container: false,
                rotas: [],
                mercadorias: []
            },
            maskMoney: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            },
            lstMercadorias: [],
            cabecalhoGridMercadorias: [
                {text: 'Mercadoria', value: 'mercadoria'},
                {text: 'Valor médio', value: 'valorMedio'},
                {text: 'Percentual', value: 'percentual'},
                {text: '', value: ''}
            ],
            cabecalhoGridRotas: [
                {text: 'Origem', value: 'origem'},
                {text: 'Destino', value: 'destino'},
                {text: 'Percentual', value: 'percentual'},
                {text: '', value: ''}
            ],
            errorMessages: {
                mercadoria: [],
                txtValorMedioMercadoria: [],
                txtPercentualMercadoria: [],
                txtOrigemRota: [],
                txtDestinoRota: [],
                txtPercentualRota: []
            },
            estados: []
        }
    },

    mounted: function () {
        this.resetDataHoraInicio();
        this.carregaMercadorias();
        this.carregaEstados();
    },
    computed: {
        disableMercadorias() {
            return this.protocolo != null || this.dadosQuestionarioCompleto.id != null
        },
        elementoPai: function () {
            return this.$parent.$parent.$parent;
        },
        lstSelectMercadoria: function () {
            let idsSelecionados = this.dadosOperacionais.mercadorias.map((x) => { return x.mercadoria.id });

            return this.lstMercadorias.filter((x) => { return idsSelecionados.indexOf(x.id) == -1 });
        },
        percentualRotasValid: function () {
            return this.somaPercentual(this.dadosOperacionais.rotas) == 100;
        },
        percentualMercadoriasValid: function () {
            return this.somaPercentual(this.dadosOperacionais.mercadorias) == 100;
        },
        percentualVeiculosValid: function () {
        
        if( this.dadosOperacionais.percentualVeiculoProprio != 0 ||  
            this.dadosOperacionais.percentualVeiculoAgregado != 0 ||
            this.dadosOperacionais.percentualVeiculoAutonomo != 0 ) {
                if( this.modelFormatado.percentualVeiculoProprio == '' &&
                    this.modelFormatado.percentualVeiculoAgregado   == '' &&
                    this.modelFormatado.percentualVeiculoAutonomo   == '') {
                    return true;
                }
            return (this.dadosOperacionais.percentualVeiculoProprio + 
                    this.dadosOperacionais.percentualVeiculoAgregado +
                    this.dadosOperacionais.percentualVeiculoAutonomo) == 100;
        }
        else { 
            return true;
        }
        },
        passoValido: function () {
            return this.formValidDadosOperacionais &&  
                this.dadosOperacionais.mercadorias.length > 0 &&
                this.percentualMercadoriasValid;
        },
        maskComputed: function() {
            return mask; 
        },
        functionsComputed: function() {
            return functions;
        },
    },
    watch: {
        dadosQuestionarioCompleto(val) {
            if(val.id != null  &&  val.id != undefined) {
                for(var mercadoria of this.dadosQuestionarioCompleto.dadosOperacionais.mercadorias) {
                    this.dadosOperacionais.mercadorias.push({
                        mercadoria: {
                            descricao: mercadoria.mercadoria.descricao,
                            id: mercadoria.mercadoria.id,
                            proibida: mercadoria.mercadoria.proibida
                        },
                        percentual: mercadoria.percentual,
                        valorMedio: mercadoria.valorMedio,
                    });
                }
            }
         },
        'modelFormatado.valorTransportadoMes': function (val) {
            this.dadosOperacionais.valorTransportadoMes = CustomFormat.removeMoneyFormat(val);
        },
        'modelFormatado.maiorValorEmbarcado': function (val) { 
            this.dadosOperacionais.maiorValorEmbarcado = CustomFormat.removeMoneyFormat(val);
        },
        'modelFormatado.percentualVeiculoProprio': function (val) { 
            this.dadosOperacionais.percentualVeiculoProprio = CustomFormat.removePercentFormat(val);
            if(this.dadosOperacionais.percentualVeiculoProprio == undefined) {
                this.dadosOperacionais.percentualVeiculoProprio = 0
            }
        },
        'modelFormatado.percentualVeiculoAgregado': function (val) { 
            this.dadosOperacionais.percentualVeiculoAgregado = CustomFormat.removePercentFormat(val);
            if(this.dadosOperacionais.percentualVeiculoAgregado == undefined) {
                this.dadosOperacionais.percentualVeiculoAgregado = 0
            }
        },
        'modelFormatado.percentualVeiculoAutonomo': function (val) {
            this.dadosOperacionais.percentualVeiculoAutonomo = CustomFormat.removePercentFormat(val);
            if(this.dadosOperacionais.percentualVeiculoAutonomo == undefined) {
            this.dadosOperacionais.percentualVeiculoAutonomo = 0
            }
        },
        'modelFormatado.percentualRotaMaiorFrequencia': function (val) { 
            this.modelRotaMaiorFrequencia.percentual = CustomFormat.removePercentFormat(val);
        },
        'modelFormatado.percentualMercadoriaTransportada': function (val) {
            this.modelMercadoriaTransportada.percentual = CustomFormat.removePercentFormat(val);
        },
        'modelFormatado.valorMercadoriaTransportada': function (val) { 
            this.modelMercadoriaTransportada.valorMedio = CustomFormat.removeMoneyFormat(val);
        },
    },
    methods: {
        usarQuestionarioPai: function (param) {
            const self = this;
            self.questionarioClonado = true;
            self.questionarioPai = param;        
            self.dadosOperacionais = self.questionarioPai;
            
            self.$refs.txtDadosOperacionaisValorTransportadoMes.$el.getElementsByTagName('input')[0].value = self.questionarioPai.valorTransportadoMes.toFixed(2);
            self.$refs.txtDadosOperacionaisQuantidadeViagensMes.$el.getElementsByTagName('input')[0].value = self.questionarioPai.quantidadeViagensMes;
            self.$refs.txtDadosOperacionaisMaiorValorEmbarcado.$el.getElementsByTagName('input')[0].value = self.questionarioPai.maiorValorEmbarcado.toFixed(2);
            
            if (self.questionarioPai.percentualVeiculoProprio > 0)
                self.modelFormatado.percentualVeiculoProprio = CustomFormat.pontoParaVirgula(self.questionarioPai.percentualVeiculoProprio);
            if (self.questionarioPai.percentualVeiculoAgregado > 0)
                self.modelFormatado.percentualVeiculoAgregado = CustomFormat.pontoParaVirgula(self.questionarioPai.percentualVeiculoAgregado);
            if (self.questionarioPai.percentualVeiculoAutonomo > 0)
                self.modelFormatado.percentualVeiculoAutonomo = CustomFormat.pontoParaVirgula(self.questionarioPai.percentualVeiculoAutonomo);

            
            self.passoValido;
            self.formValidDadosOperacionais = true;
            
        },
        resetDataHoraInicio: function () {
            this.dataHoraInicio = new Date();
        },
        somaTempoPreenchimentoTotal: function () {
            const self = this;
            var dateTimeNow = new Date();
            if (self.tempoPreenchimentoTotal == '') {
                self.tempoPreenchimentoTotal = parseInt(((dateTimeNow.getTime()/1000)/60) - ((self.dataHoraInicio.getTime()/1000)/60));
            } else {
                self.tempoPreenchimentoTotal += (parseInt(((dateTimeNow.getTime()/1000)/60) - ((self.dataHoraInicio.getTime()/1000)/60)));
            }
        },
        carregaEstados: function () {
            const self = this;
            axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstados`)
            .then((response) => {
                self.estados = response.data.sort((a, b) => { return a.sigla.localeCompare(b.sigla) });
                let diversos = self.estados.splice(7,1).pop();
                self.estados.push(diversos);
            });

        },
        carregaMercadorias: function () {
            const self = this;
            if (axios) {
                axios.get(`${process.env.URL_MERCADORIAMS}/v1/no-auth/buscaTodasMercadorias`)
                .then((response) => {
                    const data = response.data;
                    if (data) {
                        self.lstMercadorias = data;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            }
        },
        buscaDescricaoMercadoria: function (idMercadoria) {
            return this.lstMercadorias.find((x) => { return x.id == idMercadoria }).descricao;
        },
        buscaSiglaEstado: function (idEstado) {
            if (this.estados.length > 0 && idEstado) {
                return this.estados.find((x) => { return x.id == idEstado}).sigla;
            }
        },
        somaPercentual: function (array) {
            if (array.length > 0) {
                let percentuais = array.map(x => { return x.percentual; });
                let soma = percentuais.reduce((a, b) => { return a + b });
                return soma;
            }
            return 0;
        },
        desabilitaBotao(listaMercadoriasTransportadas) {
            let valorTotal = 
            listaMercadoriasTransportadas.reduce((acc, cur) => acc + (parseInt(cur.percentual) || 0), 0);
            if(valorTotal == 100){
                return true
            }
            return false

        },
        adicionaRota: function () {
            const self = this;

            if (self.validaAddRota()) {
                self.dadosOperacionais.rotas.push(Object.assign({}, self.modelRotaMaiorFrequencia));
                self.limpaCamposRotas();
            }
        },
        validaAddRota: function () {
            const self = this;
            let erro = false;
            var somaPercentualDiversosInseridos = self.calculaPercentualDasRotasDiversasInseridas();

            self.errorMessages.txtOrigemRota = [];
            if (self.modelRotaMaiorFrequencia.idEstadoOrigem <= 0) {
                erro = erro || true;
                self.errorMessages.txtOrigemRota = ["Você não pode deixar este campo em branco"]
            }

            self.errorMessages.txtDestinoRota = [];
            if (self.modelRotaMaiorFrequencia.idEstadoDestino <= 0) {
                erro = erro || true;
                self.errorMessages.txtDestinoRota = ["Você não pode deixar este campo em branco"]
            }

            self.errorMessages.txtPercentualRota = [];
            if (self.modelRotaMaiorFrequencia.percentual <= 0 || self.modelRotaMaiorFrequencia.percentual > 100) {
                erro = erro || true;
                self.errorMessages.txtPercentualRota = ["Você precisa informar um percentual válido"]
            } else if ( isNaN(self.modelRotaMaiorFrequencia.percentual) ) {
                erro = erro || true;
                self.errorMessages.txtPercentualRota = ["Você precisa informar um percentual válido"]
            } else if (self.somaPercentual(self.dadosOperacionais.rotas) + self.modelRotaMaiorFrequencia.percentual > 100) {
                erro = erro || true;
                self.errorMessages.txtPercentualRota = ["O percentual ultrapassa os 100 % com este valor"]
            } else if ((self.modelRotaMaiorFrequencia.idEstadoOrigem == 28) && ((somaPercentualDiversosInseridos + self.modelRotaMaiorFrequencia.percentual) > 20)) {
                erro = erro || true;
                self.errorMessages.txtPercentualRota = ["O percentual de origens/destinos diversos ultrapassa os 20 % com este valor"]
            } else if ((self.modelRotaMaiorFrequencia.idEstadoDestino == 28) && ((somaPercentualDiversosInseridos + self.modelRotaMaiorFrequencia.percentual) > 20)) {
                erro = erro || true;
                self.errorMessages.txtPercentualRota = ["O percentual de origens/destinos diversos ultrapassa os 20 % com este valor"]
            }

            return !erro;
        },
        calculaPercentualDasRotasDiversasInseridas: function () { 
            const self = this;
            var somaPercentualDiversosInseridos = 0;        
            var rotasComOrigensDestinosDiversos = self.dadosOperacionais.rotas.filter((obj) => {
                return (obj.idEstadoOrigem == 28 || obj.idEstadoDestino == 28)
            });
            if (rotasComOrigensDestinosDiversos.length > 0) {
                for (var i = 0; i < rotasComOrigensDestinosDiversos.length; i++) {
                    somaPercentualDiversosInseridos += rotasComOrigensDestinosDiversos[i].percentual;
                }
            }
            return somaPercentualDiversosInseridos;
        },
        removeRota: function (item) {
            let index = this.dadosOperacionais.rotas.indexOf(item);
            this.dadosOperacionais.rotas.splice(index, 1);
        },
        limpaCamposRotas: function () {
            const self = this;
            self.modelRotaMaiorFrequencia.idEstadoOrigem = 0;
            self.modelRotaMaiorFrequencia.idEstadoDestino = 0;
            let somaRotas = self.somaPercentual(self.dadosOperacionais.rotas);
            self.modelFormatado.percentualRotaMaiorFrequencia = (100 - somaRotas).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        adicionaMercadoria: function () {
            const self = this;
            if (self.validaAddMercadoria()) {
                self.dadosOperacionais.mercadorias.push(Object.assign({}, self.modelMercadoriaTransportada));
                self.limpaCamposMercadoria();
            }
        },
        deleteMercadoria (item) {
        const index = this.listaMercadoriasTransportadas.indexOf(item);
        this.listaMercadoriasTransportadas.splice(index, 1);
        },

        salvarOportunidade() {
        this.dadosOperacionais.mercadorias.forEach(element=>{
            let auxLista = {idMercadoria:element.mercadoria.id, valorMedio:element.valorMedio, percentual:element.percentual}
            this.lstSalvarOportunidade.push(auxLista);
        })

        axios

            .post(
            `${process.env.URL_QUESTIONARIOMS}/v1/salvarOportunidade`,this.lstSalvarOportunidade,

            {
                headers: {
                    Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                }
            }
            )

            .then(response => {
            })

            .catch(error => {
            if (error.response && error.response.data) {
                this.snack = true;

                this.snackColor = "red";

                this.snackText = error.response.data.message;
            }
            })

            .finally(() => {
            setTimeout(() => {
            
            }, 1000);
            });
        },

        validaAddMercadoria: function() {
            const self = this;
            let erro = false;
            var somaPercentualMercadoriasDiversasInseridas = self.calculaPercentualDasMercadoriasDiversasInseridas();
            self.errorMessages.mercadoria = [];
            if (Object.keys(self.modelMercadoriaTransportada.mercadoria).length === 0) {
                erro = erro || true;
                self.errorMessages.mercadoria = ["Você não pode deixar este campo em branco"]
            }

            self.errorMessages.txtValorMedioMercadoria = [];
            if (self.modelMercadoriaTransportada.valorMedio <= 0) {
            erro = erro || true;
            self.errorMessages.txtValorMedioMercadoria = ["Você precisa informar um valor válido"]
            }

            self.errorMessages.txtPercentualMercadoria = [];
            if (self.modelMercadoriaTransportada.percentual <= 0 || self.modelMercadoriaTransportada.percentual > 100) {
                erro = erro || true;
                self.errorMessages.txtPercentualMercadoria = ["Você precisa informar um percentual válido"]
            } else if ( isNaN(self.modelMercadoriaTransportada.percentual) ) {
                erro = erro || true;
                self.errorMessages.txtPercentualRota = ["Você precisa informar um percentual válido"]
            } else if (self.somaPercentual(self.dadosOperacionais.mercadorias) + self.modelMercadoriaTransportada.percentual > 100) {
                erro = erro || true;
                self.errorMessages.txtPercentualMercadoria = ["O percentual ultrapassa os 100 % com este valor"]
            } else if ((self.modelMercadoriaTransportada.mercadoria.id == 279) && ((somaPercentualMercadoriasDiversasInseridas + self.modelMercadoriaTransportada.percentual) > 20)) {
                erro = erro || true;
                self.errorMessages.txtPercentualMercadoria = ["O percentual de mercadorias diversas ultrapassa os 20 % com este valor"]
            }

            return !erro;
        },
        calculaPercentualDasMercadoriasDiversasInseridas: function () {
            const self = this;
            var somaPercentualMercadoriasDiversasInseridas = 0;        
            var mercadoriasDiversas = self.dadosOperacionais.mercadorias.filter((obj) => {
                return (obj.idEstadoDestino == 279)
            });
            if (mercadoriasDiversas.length > 0) {
                for (var i = 0; i < mercadoriasDiversas.length; i++) {
                    somaPercentualMercadoriasDiversasInseridas += mercadoriasDiversas[i].percentual;
                }
            }
            return somaPercentualMercadoriasDiversasInseridas;
        },
        removeMercadoria: function (idMercadoria) {
            const self = this;
            self.dadosOperacionais.mercadorias = self.dadosOperacionais.mercadorias.filter(x => { return x.mercadoria.id != idMercadoria});
        },
        limpaCamposMercadoria: function () {
            const self = this;
            self.modelMercadoriaTransportada.mercadoria = {};
            //self.$refs.txtValorMedioMercadoria.$el.getElementsByTagName('input')[0].value = 0;

            let somaMercadorias = self.somaPercentual(self.dadosOperacionais.mercadorias);
            self.modelFormatado.percentualMercadoriaTransportada = (100 - somaMercadorias).toLocaleString('pt-BR');
        },
        montaModelo: function () {
            return this.dadosOperacionais;
        },
        toStrB: function (value) {
            return value.toString();
        },
        toMoneyString: function (val) {
            return CustomFormat.toMoneyString(val);
        },
        toPercentString: function (val) {
            return CustomFormat.toPercentString(val);
        }
    }
}
</script>
<style>
   .QuestionarioAnaliseRiscos .telaMercadorias{
        margin-top: 32px;
    }
    .somaPercentual {
        color: red;
    }
    .transporte {
        margin-left: 25px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARMercadoriasTransportadas.vue